module.exports = __webpack_public_path__ + "static/alert-task-dont-dc5ae12ae4f6442ebbe5de1ea279c14e.png";